import React, {useState} from "react"

// context
const BuddyContext = React.createContext()

// provider
function BuddyProvider(props) {
  const [budget, setBudget] = useState(200)
  const [remainingBudget, setRemainingBudget] = useState(200)

  let value = {
    // properties
    budget,
    remainingBudget,

    // functions
    addActivity: (activity) => {
      setRemainingBudget(100) // TODO hardcoded
    },
    init: async(id) => {
      //let initResult = await Buddy.init(id)
      setBudget(200) // TODO hardcoded
    }
  }

  return (
    <BuddyContext.Provider value={value}>
      {props.children}
    </BuddyContext.Provider>
  )
}

export {BuddyContext, BuddyProvider}